import { combineReducers } from "@reduxjs/toolkit";
import operatorSlice from "./operatorSlice/operatorSlice";
import cbmSlice from "./cbmSlice/cbmSlice";
import editOperatorSlice from "./operatorSlice/editOperatorSlice";

const reducers = combineReducers({
    operatorSlice: operatorSlice,
    editOperatorSlice: editOperatorSlice,
    cbmSlice: cbmSlice
});

export default reducers;
